<router-outlet />
<div id="splash">
</div>
